import React, { useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import OrderTracking from "@/components/OrderTracking";
import Seo from "@/components/Seo";

/**
 * /track?order_id=cs_xxx — auto-fills the OrderTracking form so the customer
 * can land here from their confirmation email with one click.
 */
export default function Track() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id") || "";
  const email = params.get("email") || "";

  useEffect(() => {
    // Pre-populate the inputs in OrderTracking before its initial render.
    if (orderId) {
      const tryFill = () => {
        const el = document.querySelector('[data-testid="track-order-id-input"]');
        if (el) { el.value = orderId; el.dispatchEvent(new Event("input", { bubbles: true })); return true; }
        return false;
      };
      // OrderTracking renders on its own, so retry a few times until present.
      let attempts = 0;
      const timer = setInterval(() => {
        if (tryFill() || ++attempts > 8) clearInterval(timer);
      }, 80);
      return () => clearInterval(timer);
    }
    if (email) {
      const tryFill = () => {
        const el = document.querySelector('[data-testid="track-order-email-input"]');
        if (el) { el.value = email; el.dispatchEvent(new Event("input", { bubbles: true })); return true; }
        return false;
      };
      let attempts = 0;
      const timer = setInterval(() => {
        if (tryFill() || ++attempts > 8) clearInterval(timer);
      }, 80);
      return () => clearInterval(timer);
    }
  }, [orderId, email]);

  return (
    <div className="min-h-screen bg-[#fafaf9]">
      <Seo
        title="Track Your Order · Dubai Pillows"
        description="Look up your Dubai Pillows order in seconds. Enter your Order ID or email and see your live shipping status."
        url="https://goose-down-elite.emergent.host/track"
        keywords="track order dubai pillows, shipping status, where is my pillow"
      />
      <header className="px-6 md:px-10 py-5 flex items-center justify-between">
        <Link to="/" className="text-[18px] font-black tracking-tight text-[#0e0e10]">
          Dubai Pillows
        </Link>
        <Link to="/" className="text-[12px] uppercase tracking-wider text-[#5a5a60] hover:text-[#0e0e10]">
          ← Back to shop
        </Link>
      </header>
      <OrderTracking />
    </div>
  );
}
